import {get, post} from '@/utils/http'
import {getDeviceFingerprint} from "@/utils/util";


/**
 * 获取用户信息
 * @returns {Promise<ResultDTO<>>}
 */
async function downloadRecord(shareToken) {
    const fingerPrint = getDeviceFingerprint();
    return await post('/share/download', {fingerPrint, shareToken})
}

/**
 * 注册用户
 * @param user
 * @returns {Promise<ResultDTO<>>}
 */
async function getShareToken(){
    const fingerPrint = getDeviceFingerprint();
    return await post("/share/get/token", {fingerPrint});
}

export default {
    getShareToken,downloadRecord
}
